import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges, OnChanges } from '@angular/core'
import { ListingItem } from 'depoto-core/src/models'
import { CoreService } from '../../../services'
import { File } from 'depoto-core/src/entities'
import { getThumbUrl as imageGetThumbUrl } from '../../../utils'

@Component({
  selector: 'app-base-listing',
  templateUrl: './base-listing.component.html',
  styleUrls: ['./base-listing.component.scss'],
})
export class BaseListingComponent implements OnInit, OnDestroy, OnChanges {
  @Input() listName: string
  @Input() items: any[] = []
  @Input() columns: ListingItem[] = []
  @Input() isColumnSettingVisible = false
  @Input() totalItems = 0
  @Input() currentPage: number
  @Input() endPage: number
  @Input() filters: any
  @Input() loadStringifiedFilters = false
  @Input() sortProp = 'id'
  @Output() sortPropChange: EventEmitter<any> = new EventEmitter()
  @Input() sortDir = 'desc'
  @Output() sortDirChange: EventEmitter<any> = new EventEmitter()
  @Input() loadingItems = false
  @Input() loadingNextItems = true
  @Input() stringifiedFilters: string
  @Input() storageKey: { type: string; key: string } // todo Vasek; test pls
  @Output() reloadList: EventEmitter<any> = new EventEmitter()
  @Output() switchPage: EventEmitter<any> = new EventEmitter()
  @Output() callAction: EventEmitter<any> = new EventEmitter()
  @Output() checkboxChange: EventEmitter<any> = new EventEmitter()
  @Output() handleSelectedItem: EventEmitter<number> = new EventEmitter()
  @Output() selectedColumnsChange: EventEmitter<ListingItem[]> = new EventEmitter()
  public selectedColumns: ListingItem[] = []
  public isAllSelected = false

  constructor(public core: CoreService) {}

  ngOnInit() {
    this.loadSettings()
    setTimeout(() => {
      this.selectedColumnsChange.emit(this.selectedColumns)
    }, 300)
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.storageKey?.currentValue) {
      this.loadSettings()
    }
  }

  saveSettings(): void {
    const savedColumns = this.core.services.storage.getSync(this.storageKey) || {}
    savedColumns[this.listName] = [...this.selectedColumns]
    this.core.services.storage.set(this.storageKey, savedColumns)
  }

  loadSettings(): void {
    const savedColumns = this.core.services.storage.getSync(this.storageKey)
    if (this.isColumnSettingVisible) {
      this.selectedColumns = [...this.columns.filter(c => c.isDefault)]
    } else {
      this.selectedColumns = [...this.columns]
    }
    if (savedColumns && savedColumns[this.listName]?.length > 0) {
      this.selectedColumns = savedColumns[this.listName].map(c => this.columns.filter(col => col.name === c.name)[0])
    }
  }

  ngOnDestroy() {
    window.onscroll = null
  }

  paginate(event): void {
    this.switchPage.emit({
      currentPage: event.currentPage,
      sortProp: event.sortProp,
      sortDir: event.sortDir,
      concat: event.concat,
    })
  }

  sortBy(property: string): void {
    if (this.sortProp === property) {
      this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc'
      this.sortDirChange.emit(this.sortDir)
    } else {
      this.sortProp = property
      this.sortPropChange.emit(this.sortProp)
    }
    this.currentPage = 1
    this.switchPage.emit({
      currentPage: this.currentPage,
      sortProp: this.sortProp,
      sortDir: this.sortDir,
      concat: false,
    })
  }

  onAction(action: string, item: any) {
    this.callAction.emit({
      action: action,
      item: item,
    })
  }

  onColumnSettingDropdownClick(event: string) {
    const isSelected = this.selectedColumns.filter(c => c.name === event).length > 0
    if (isSelected) {
      this.selectedColumns = this.selectedColumns.filter(c => c.name !== event)
    } else {
      this.selectedColumns = [...this.selectedColumns, ...this.columns.filter(c => c.name === event)]
      // sorting by reference arr (includes() breaks if isSelected - different objects..):
      this.selectedColumns = this.columns.filter(c => this.selectedColumns.includes(c))
    }

    this.selectedColumnsChange.emit(this.selectedColumns)
    this.saveSettings()
  }

  public trackByColumnName(index: number, column: ListingItem): string {
    return column.name
  }

  public trackByIndex(index: number) {
    return index
  }

  onCheckboxChange(itemId, value) {
    if (itemId === 0) {
      this.items.forEach((it, i) => {
        this.items[i].isSelected = value
      })
    }
    this.checkboxChange.emit({ id: itemId, value })
  }

  getThumbUrl(image: File, format: 'w135wp' | 'w2048wp' = 'w135wp'): string {
    return imageGetThumbUrl(image, format)
  }

  public saveSelectedItem(id): void {
    this.handleSelectedItem.emit(id)
  }
}
